import { ExpressPaymentMethod } from '@grandvisionhq/payments'

export const getPageTitle = (type: ExpressPaymentMethod): string =>
  type === ExpressPaymentMethod.APPLE_PAY ? 'Apple Pay Express Checkout' : 'Express Checkout'
